import { render, staticRenderFns } from "./bibangReviewRegModal.vue?vue&type=template&id=537b937a&scoped=true"
import script from "./bibangReviewRegModal.vue?vue&type=script&lang=js"
export * from "./bibangReviewRegModal.vue?vue&type=script&lang=js"
import style0 from "./bibangReviewRegModal.vue?vue&type=style&index=0&id=537b937a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b937a",
  null
  
)

export default component.exports